<ng-container class="banner-skeleton" *ngIf="loading; else content">
  <!-- Skeleton loader -->
  <nz-skeleton
    [nzLoading]="loading"
    [nzParagraph]="{ rows: 1 }"
    [nzActive]="true"
    [nzAvatar]="true"
  ></nz-skeleton>
</ng-container>
<ng-template #content>
  <div
    *ngIf="!dismissBanners && showBanner"
    class="box-payment fs-22 flex"
    [style.background-color]="color"
  >
    <div class="rectangle-payment flex fs-20">
      <div class="image-payment">
        <img [src]="images.BANNER_MASCOT" class="img-45" alt="mascot" />
      </div>
      <div class="text-payment" [innerHTML]="sanitizeHtml(paymentText)"></div>
      <div (click)="showPayment()" class="details-payment">
        {{ 'ORDER_DASHBOARD.VIEW_DETAILS' | fallbackTranslate }}
      </div>
    </div>
    <div (click)="dismissBanner()" *ngIf="currentDayOfMonth < 12" class="cross">
      <img [src]="images.CROSS" class="img-20" alt="close" />
    </div>
  </div>
</ng-template>
